import { render } from "./SliderFour.vue?vue&type=template&id=59e9c9c2"
import script from "./SliderFour.vue?vue&type=script&lang=js"
export * from "./SliderFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__